import Headroom from "headroom.js"

;(function (window, document) {

    'use strict'

    function isMobile() {
        return window.matchMedia("(max-width: 1023px)").matches
    }

    function isMobileNavVisible(nav) {
        if ( isMobile() ) {
            return ( nav.offsetParent !== null )
        }
        return false
    }

    function headroomInit() {
        //var header = document.querySelector(".site-header")
        var header = document.getElementById('masthead')
        var nav = document.getElementById('main-menu')

        var options = {
            // vertical offset in px before element is first unpinned
            offset: 80,
            // scroll tolerance in px before state changes
            tolerance: 5,
            // recaculate the header height when user goes to the top 
            // (use case: resize browser when scrolled part way)
            onTop: function() {
                setTimeout(function(){
                    evaluateHeaderHeight()
                }, 250)
            },
            // keep header visible if main navigation is visible on mobile
            onUnpin: function() {
                if ( isMobileNavVisible(nav) ) {
                    this.elem.classList.remove(this.classes.unpinned)
                    this.elem.classList.add(this.classes.pinned)
                }

                else {
                    this.elem.classList.add(this.classes.unpinned)
                    this.elem.classList.remove(this.classes.pinned)
                }
            }
        }

        var headroom = new Headroom(header, options)
        headroom.init()
    }

    // Simple steps to set spacing for headroom and page heros equal to menu and admin bar height
    function evaluateHeaderHeight() {

        let menuHeight = 0
        let menuHeightFull = 0

        let menuElement     = document.getElementById('main-menu')
        let adminBarElement = document.getElementById('wpadminbar')
        let headroomElement = document.querySelector('.headroom')
        let heroElement     = document.querySelector('.page-hero--full')
        let menuDrawers     = document.querySelectorAll('.site-header__menu__drawer')

        if ( menuElement ) {
            menuHeight = menuElement.offsetHeight
        }

        if ( adminBarElement ) {
            menuHeightFull = menuHeight + adminBarElement.offsetHeight
        } else {
            menuHeightFull = menuHeight
        }

        if ( headroomElement ) {
            headroomElement.style.paddingTop = menuHeight + 'px'
        }

        if ( heroElement ) {
            heroElement.style.minHeight = 'calc( 100vh - ' + menuHeightFull + 'px - 1.5rem )'
        }

        if ( menuDrawers ) {
            [].forEach.call(menuDrawers, function(drawer) {
                //console.log('resizing drawer');
                if ( isMobile() ) {
                    //console.log('setting min height')
                    drawer.style.minHeight = 'calc( 100vh - ' + menuHeightFull + 'px)'
                } else {
                    //console.log('setting  height')
                    drawer.style.height = 'calc( 100vh - ' + menuHeightFull + 'px)'
                }
            });
        }
    }

    window.addEventListener('DOMContentLoaded', () => {
        headroomInit()
        evaluateHeaderHeight()
    })

    window.addEventListener("resize", evaluateHeaderHeight)

    document.body.addEventListener('htmx:afterSwap', () => {
        headroomInit()
    })

})(window, document)